export default "__VITE_ASSET__952e6fa0__"